




























































import { CourseModuleComponentItem } from '@/store/modules/jtms/course-module/course-module.types';
import { RootState } from '@/store/store';
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

@Component({})
export default class PrerequisiteDropdown extends Vue {
  @Prop({ type: Array }) readonly value!: CourseModuleComponentItem[];
  // Receive the module's index
  @Prop(Number) moduleIndex!: number;

  @State(
    (state: RootState) =>
      state.courseModule.courseModulesTabState.activeCourseModules
  )
  activeCourseModules!: CourseModuleComponentItem[];

  @Getter('courseModule/getAvailablePrerequisitesMap')
  readonly prereqMap!: { [key: number]: CourseModuleComponentItem[] };

  // Local state for prerequisite selection
  localPrereqSelection: CourseModuleComponentItem[] = [];

  get currentCourseModule(): CourseModuleComponentItem {
    return this.activeCourseModules[this.moduleIndex];
  }

  // The computed property is now just a simple, fast lookup.
  get availablePrerequisites(): CourseModuleComponentItem[] {
    if (!this.activeCourseModules || !this.prereqMap) {
      return [];
    }
    // Return the pre-calculated array from the map, or an empty array if not found.
    return (
      this.prereqMap[this.activeCourseModules[this.moduleIndex].tempId!] || []
    );
  }

  get shouldDisabledDropdown() {
    return this.activeCourseModules[this.moduleIndex]
      .shouldDisablePrerequisiteDropdown;
  }

  removePrerequisite(moduleToRemove: CourseModuleComponentItem) {
    const newValue = this.value.filter(
      (cm) => cm.tempId !== moduleToRemove.tempId
    );
    this.emitInputEvent(newValue);
  }

  /**
   * Checks if a given prerequisite object is currently in the selection.
   * This is used to set the checked state of each individual checkbox.
   */
  isSelected(prereq: CourseModuleComponentItem): boolean {
    return this.value.some((selected) => selected.tempId === prereq.tempId);
  }

  /**
   * Handles the click event from a checkbox.
   * @param prereq The prerequisite object associated with the checkbox.
   * @param shouldBeSelected The new boolean state from the checkbox's @input event.
   */
  togglePrerequisite(
    prereq: CourseModuleComponentItem,
    shouldBeSelected: boolean
  ): void {
    let newValue = [...this.value]; // Create a new array from the prop

    if (shouldBeSelected) {
      // Add the prerequisite if it's not already there.
      if (!this.isSelected(prereq)) {
        newValue.push(prereq);
      }
    } else {
      // Remove the prerequisite.
      newValue = newValue.filter(
        (selected) => selected.tempId !== prereq.tempId
      );
    }

    // Emit the 'input' event with the newly constructed array.
    this.emitInputEvent(newValue);
  }

  @Emit('input')
  emitInputEvent(newValue: CourseModuleComponentItem[]) {
    return newValue;
  }
}
